// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const scatterbug: PokeData = {
  "id": 664,
  "name": "scatterbug",
  "height": 3,
  "weight": 25,
  "base_experience": 40,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "tackle",
    "stun-spore",
    "string-shot",
    "bug-bite"
  ],
  "moves": [
    "tackle",
    "stun-spore",
    "string-shot",
    "bug-bite",
    "signal-spam",
    "heal-order",
    "pin-missile",
    "pounce",
    "sticky-web",
    "bug-buzz",
    "pin-rush",
    "lunge",
    "leech-steal"
  ],
  "evolution_chain": {
    "id": 342,
    "item": null,
    "species": [
      {
        "name": "scatterbug",
        "order": 665,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "spewpa",
        "order": 666,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": 664,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 9,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "vivillon",
        "order": 667,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 665,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 12,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 35.25,
    "speed": 35,
    "ability_power": 35
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
